import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Button } from "antd";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import money_bag from "../../../../assets/images/money_bag.png";
import hand_money from "../../../../assets/images/hand_money.png";
import hand_rateio from "../../../../assets/images/rateio.png"; // Adicionado BELINI
import card from "../../../../assets/images/card.png";
import pix_icon from "../../../../assets/images/pix.png";
import especie_icon from "../../../../assets/images/especie.png";
import estorno_icon from "../../../../assets/images/Estorno.png";
import credito_icon from "../../../../assets/images/credito.png";
import debito_icon from "../../../../assets/images/debito.png";
import saidas_icon from "../../../../assets/images/saidas.png"; // Adicionado BELINI
import saldo_icon from "../../../../assets/images/saldo.png"; // Adicionado BELINI
import moment from "moment";

const Relatorio = () => {

  const styles = `
  .Maquinas-page {
    background-color: black;
    color: black;
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100vw;
    overflow: auto;    
  }
  .Relatorio_staBlockTitle {
  display: flex;
  justify-content: space-between;
  align-items: center; 
  gap: 20px; 
  padding: 10px 0;
  margin-top: 20px; 
  margin-left: 30px;
  }
  .Relatorio_maquina {
  font-size: 20px;
  font-weight: bold;
  color: #f1c40f;
  }
  .Relatorio_periodo {
  font-size: 20px;
  color: #2ecc71;
  }
  .Botao-Voltar {
  font-size: 20px;
  padding: 12px 30px;
  display: flex; 
  align-items: center; 
  justify-content: center; 
  text-align: center;
  border-radius: 10px;
  border: none;
  font-weight: bold;
   margin-right: 30px;
  background-color: rgb(163, 3, 163);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #ffffff;
  display: inline-flex;
  }
  .Botao-Voltar:hover {
  background-color: rgb(250, 31, 250);
  }
  .Relatorio_Dashboard_col_tableLinkA {
  color: #000000;
  }
  .Relatorio_Dashboard_col_tableLink {
    position: absolute;
    top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #878997;
  }
  .Relatorio_Dashboard_col_tableLink > div {
    padding: 0 5px;
  }
  .Relatorio:hover {
    transform: scale(1.05);
  }
  .Relatorio_left_side {
    width: 100%;
  }
  .Relatorio_os_icon {
    width: 120px;
  }
  .Relatorio_money_icon {
    width: 97px;
  }
  .Relatorio_title {
    font-size: 32px;
    font-weight: 800;
  }
  .Relatorio_value_row {
    margin-top: 40px;
  }
  .Relatorio_inner_rows {
    margin: 20px;
  }
  .Relatorio_title_col {
    display: flex;
    align-items: center;
  }
  .Relatorio_title_col_title {
    width: 15px; 
    height: 15px;
    margin-right: 5px;
  }
  .Relatorio {
    background: #fff;
    margin: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    transition: transform 100ms ease-in-out;
    padding: 20px;
    display: flex;
    justify-content: space-between;
  }
  .Relatorio2 {
    background: #fff;
    margin: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    transition: transform 100ms ease-in-out;
    padding: 20px;
    display: flex;
    justify-content: space-between;
  }
  @media only screen and (max-width: 800px) {
    .Relatorio_Dashboard_col_table {
    display: none !important;
  }
  .Relatorio_info {
      display: block !important;
  }
  }
  `;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);

  const [isLoading, setIsLoading] = useState(true);
  const { authInfo } = useContext(AuthContext);
  const { dataUser } = authInfo;
  let navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  // Eliminadas todas declarações de pagamentos desta parte - BELINI

  // useEffect() desta parte - BELINI

  // Eliminadas todas rotas que eram chamadas aqui e trocadas por apenas leitura do localStorage - BELINI

  function getValidNumber(value) { // Adicionado BELINI
    const number = parseFloat(value);
    return isNaN(number) || number <= 0 ? 0 : number;
  }

  const dataInicial = localStorage.getItem(`DataInicial`); // Lê o que gravou em localStorage - Adicionado BELINI
  const dataFinal = localStorage.getItem(`DataFinal`); // Lê o que gravou em localStorage - Adicionado BELINI
  const estornos = getValidNumber(localStorage.getItem(`Totalestorno`)); // Lê o que gravou em localStorage - Adicionado BELINI
  const cash = getValidNumber(localStorage.getItem(`Totalcash`)); // Lê o que gravou em localStorage - Adicionado BELINI
  const entradas = getValidNumber(localStorage.getItem(`Totalgeral`)); // Lê o que gravou em localStorage - Adicionado BELINI
  const saidas = getValidNumber(localStorage.getItem(`Totalsaidas`)); // Lê o que gravou em localStorage - Adicionado BELINI
  const saldo = getValidNumber(localStorage.getItem(`Totalsaldo`)); // Lê o que gravou em localStorage - Adicionado BELINI
  const pix = getValidNumber(localStorage.getItem(`TotalPix`));  // Lê o que gravou em localStorage - Adicionado BELINI
  const credito = getValidNumber(localStorage.getItem(`TotalCredito`));  // Lê o que gravou em localStorage - Adicionado BELINI
  const debito = getValidNumber(localStorage.getItem(`TotalDebito`));  // Lê o que gravou em localStorage - Adicionado BELINI
  const taxapix = getValidNumber(localStorage.getItem(`TaxaPix`)); // Lê o que gravou em localStorage - Adicionado BELINI
  const taxacredito = getValidNumber(localStorage.getItem(`TaxaCredito`)); // Lê o que gravou em localStorage - Adicionado BELINI
  const taxadebito = getValidNumber(localStorage.getItem(`TaxaDebito'`));  // Lê o que gravou em localStorage - Adicionado BELINI
  const nome = localStorage.getItem(`Textonome`);  // Lê o que gravou em localStorage - Adicionado BELINI

  // console.log(`Valor lido do localStorage Admin: ${nome}`);

  const Totalestornos = pix + credito + debito + estornos; // Adicionado BELINI
  const Totalvalidado = Totalestornos - estornos; // Adicionado BELINI
  const Totaltaxapix = pix + taxapix; // Adicionado BELINI
  const Totaltaxacredito = credito + taxacredito; // Adicionado BELINI
  const Totaltaxadebito = debito + taxadebito; // Adicionado BELINI
  const Totaltaxas = taxapix + taxadebito + taxacredito; // Adicionado BELINI

  let Pctvalidado, Pctestornos, Pctcash, Pctsaidas, Pctsaldo, Pctcredito, Pctdebito;
  let Pcttaxapix, Pctpix, Pcttaxacredito, Pcttaxadebito;

  if (estornos > 0) { // Adicionado BELINI
    Pctestornos = (estornos / Totalestornos) * 100;
  } else {
    Pctestornos = 0;
  }
  if (Totalvalidado > 0) { // Adicionado BELINI
    Pctvalidado = (Totalvalidado / Totalestornos) * 100;
  } else {
    Pctvalidado = 0;
  }
  if (cash > 0) {  // Adicionado BELINI
    Pctcash = (cash / entradas) * 100;
  } else {
    Pctcash = 0;
  }
  if (saidas > 0) { // Adicionado BELINI
    Pctsaidas = (saidas / entradas) * 100;
  } else {
    Pctsaidas = 0;
  }
  if (saldo > 0) { // Adicionado BELINI
    Pctsaldo = (saldo / entradas) * 100;
  } else {
    Pctsaldo = 0;
  }
  if (pix > 0) { // Adicionado BELINI
    Pctpix = (pix / entradas) * 100;
  } else {
    Pctpix = 0;
  }
  if (credito > 0) { // Adicionado BELINI
    Pctcredito = (credito / entradas) * 100;
  } else {
    Pctcredito = 0;
  }
  if (debito > 0) { // Adicionado BELINI
    Pctdebito = (debito / entradas) * 100;
  } else {
    Pctdebito = 0;
  }
  if (taxapix > 0) { // Adicionado BELINI
    Pcttaxapix = (taxapix / Totaltaxapix) * 100;
  } else {
    Pcttaxapix = 0;
  }
  if (taxacredito > 0) { // Adicionado BELINI
    Pcttaxacredito = (taxacredito / Totaltaxacredito) * 100;
  } else {
    Pcttaxacredito = 0;
  }
  if (taxadebito > 0) { // Adicionado BELINI
    Pcttaxadebito = (taxadebito / Totaltaxadebito) * 100;
  } else {
    Pcttaxadebito = 0;
  }

  const FormatDate = (dateString) => { // Adicionado BELINI
    if (!dateString) return '--';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '--';
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

  const formatValue = (value) => { // mostrar apenas 2 casas decimais - BELINI
    if (typeof value === 'number') {
      return value.toFixed(2);
    }
    return value;
  };

  const formatInicial = FormatDate(dataInicial); // Adicionado BELINI
  const formatFinal = FormatDate(dataFinal); // Adicionado BELINI

  // console.log("formatInicial", formatInicial)
  //  console.log("formatFinal", formatFinal)

  const fetchData = async () => {
    try {
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // setNotiMessage({type: "error", message: "Recarregando pagina...", });
    }
  };

  useEffect(() => {
    fetchData();
    const intervalId = setInterval(() => {
      fetchData();
    }, 60000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="Maquinas-page">
      {isLoading && <LoadingAction />}
      <div className="Cliente_WarningMsgSpan">
        <span>{dataUser?.warningMsg}</span>
      </div>

      <div className="Relatorio_staBlockTitle">
        <div className="Relatorio_maquina"> RELATÓRIO MÁQUINA: {nome} </div>
        <div className="Relatorio_periodo"> PERÍODO DE :&nbsp;{formatInicial}&nbsp;ATÉ:&nbsp;{formatFinal} </div>
        <Button
          className="Botao-Voltar"
          onClick={() => {
            navigate(`/pagamentos/${id}`, {
              state: location.state,
            });
          }}
        >
          <span>VOLTAR</span>
        </Button>
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12} lg={12} xl={12}>
          <div className="Relatorio">
            <div className="Relatorio_left_side">
              <div className="Relatorio_title">Entradas</div>
              <div className="Relatorio_inner_rows">
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={especie_icon} alt="Espécie" />
                    Espécie:
                  </Col>
                  <Col span={12}>{formatValue(Pctcash)}%</Col> {/* Alterado BELINI */}
                </Row>
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={credito_icon} alt="Crédito" />
                    Crédito:
                  </Col>
                  <Col span={12}>{formatValue(Pctcredito)}%</Col> {/* Alterado BELINI */}
                </Row>
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={debito_icon} alt="Débito" />
                    Débito:
                  </Col>
                  <Col span={12}>{formatValue(Pctdebito)}%</Col> {/* Alterado BELINI */}
                </Row>
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={pix_icon} alt="PIX" />
                    Pix:
                  </Col>
                  <Col span={12}>{formatValue(Pctpix)}%</Col> {/* Alterado BELINI */}
                </Row>
              </div>
            </div>
            <div className="Relatorio_right_side">
              <img className="Relatorio_money_icon" src={money_bag} alt="money icon" />
            </div>
          </div>
        </Col>

        <Col xs={24} md={12} lg={12} xl={12}>
          <div className="Relatorio">
            <div className="Relatorio_left_side">
              <div className="Relatorio_title">Taxas</div>
              <div className="Relatorio_inner_rows">
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={estorno_icon} alt="Total Taxas" />
                    Total Taxas:
                  </Col>
                  <Col span={12}>R${formatValue(Totaltaxas)}</Col> {/* Adicionado BELINI */}
                </Row>
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={credito_icon} alt="Taxas Crédito" />
                    Crédito:
                  </Col>
                  <Col span={12}>{formatValue(Pcttaxacredito)}%</Col> {/* Alterado BELINI */}
                </Row>
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={debito_icon} alt="Taxas Débito" />
                    Débito:
                  </Col>
                  <Col span={12}>{formatValue(Pcttaxadebito)}%</Col> {/* Alterado BELINI */}
                </Row>
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={pix_icon} alt="Taxas PIX" />
                    Pix:
                  </Col>
                  <Col span={12}>{formatValue(Pcttaxapix)}%</Col> {/* Alterado BELINI */}
                </Row>
              </div>
            </div>
            <div className="Relatorio_right_side">
              <img className="Relatorio_money_icon" src={hand_money} alt="money icon" />
            </div>
          </div>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12} lg={12} xl={12}>
          <div className="Relatorio">
            <div className="Relatorio_left_side">
              <div className="Relatorio_title">Rateio</div> {/* Adicionado BELINI */}
              <div className="Relatorio_inner_rows">
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={especie_icon} alt="Valor Total" />
                    Valor Total:
                  </Col>
                  <Col span={12}>R${formatValue(entradas)}</Col> {/* Adicionado BELINI */}
                </Row>
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={saidas_icon} alt="Saídas" />
                    Saídas:
                  </Col>
                  <Col span={12}>{formatValue(Pctsaidas)}%</Col> {/* Adicionado BELINI */}
                </Row>
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={saldo_icon} alt="Saldo" />
                    Saldo:
                  </Col>
                  <Col span={12}>{formatValue(Pctsaldo)}%</Col> {/* Adicionado BELINI */}
                </Row>
              </div>
            </div>
            <div className="Relatorio_right_side">
              <img className="Relatorio_money_icon" src={hand_rateio} alt="money icon" />
            </div>
          </div>
        </Col>

        <Col xs={24} md={12} lg={12} xl={12}>
          <div className="Relatorio">
            <div className="Relatorio_left_side">
              <div className="Relatorio_title">Entradas Online</div> {/* Alterado BELINI */}
              <div className="Relatorio_inner_rows">
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={especie_icon} alt="Total Válido" />
                    Total Válido:
                  </Col>
                  <Col span={12}>R${formatValue(entradas)}</Col> {/* Adicionado BELINI */}
                </Row>
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={estorno_icon} alt="Estornos" />
                    Estornado:
                  </Col>
                  <Col span={12}>{formatValue(Pctestornos)}%</Col> {/* Alterado BELINI */}
                </Row>
                <Row className="Relatorio_value_row">
                  <Col span={12}>
                    <img className="Relatorio_title_col_title" src={especie_icon} alt="Estornos" />
                    Validado:
                  </Col>
                  <Col span={12}>{formatValue(Pctvalidado)}%</Col> {/* Alterado BELINI */}
                </Row>
              </div>
            </div>
            <div className="Relatorio_right_side">
              <img className="Relatorio_money_icon" src={card} alt="money icon" />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Relatorio;
